import { useEffect, useState } from "react";
import { FieldMappingOptions } from "../../../../../../../../models/Entities";
import {
  getLinkedAccountFieldMappings,
  reconstructRootObjectValues,
} from "../../../../../../configuration/field-mappings/utils/FieldMappingUtils";

interface Params {
  linkedAccountId: string;
  selectedCommonModel: string | null;
  isCompleteResponseLoaded: boolean;
  enabled: boolean;
}

const usePartialFieldMappingOptions = ({
  linkedAccountId,
  selectedCommonModel,
  isCompleteResponseLoaded,
  enabled,
}: Params) => {
  const [partialOptionsByCommonModel, setPartialOptionsByCommonModel] = useState<{
    [commonModelName: string]: FieldMappingOptions;
  }>({});

  useEffect(() => {
    if (!enabled || !linkedAccountId || !selectedCommonModel) {
      return;
    }
    if (isCompleteResponseLoaded) {
      return;
    }
    if (partialOptionsByCommonModel[selectedCommonModel]) {
      return;
    }

    getLinkedAccountFieldMappings({
      linkedAccountID: linkedAccountId,
      common_model_name: selectedCommonModel,
      onFetch: (data) => {
        const transformedData = reconstructRootObjectValues(data);
        setPartialOptionsByCommonModel((prev) => ({
          ...prev,
          [selectedCommonModel]: transformedData.remote_field_options,
        }));
      },
      onError: () => {},
    });
  }, [
    enabled,
    linkedAccountId,
    selectedCommonModel,
    isCompleteResponseLoaded,
    partialOptionsByCommonModel,
  ]);

  return { partialOptionsByCommonModel };
};

export default usePartialFieldMappingOptions;
